<template>
  <div class="auth-layout">
    <slot></slot>
  </div>
</template>

<style scoped>
.auth-layout {
  min-height: 100vh;
  width: 100%;
  background: var(--background-primary);
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Ensure immediate rendering */
:deep(*) {
  animation: none !important;
  transition: none !important;
}
</style> 